/**
 * Cantera Stats v2 — shared constants
 *
 * Centralizes the magic strings/arrays that were duplicated across
 * EstadisticasNew.js so the v2 hooks and components can share them.
 */

export const MAX_ACTIVE_PLAYERS = 5;

export const STATS_MODE = {
  SELECTION: null,
  LIVE: 'live',
  VIDEO: 'video',
};

export const ItemTypes = { PLAYER: 'PLAYER' };

// Action codes that should trigger the shot chart overlay (in video mode)
export const SHOT_ACTION_CODES = [
  '2PTS_MADE',
  '2PTS_MISSED',
  '3PTS_MADE',
  '3PTS_MISSED',
  'FT_MADE',
  'FT_MISSED',
];

export const FREE_THROW_CODES = ['FT_MADE', 'FT_MISSED'];

// Shot qualifier toggles
export const QUALIFIERS = {
  PAINT: 'PAINT',
  FASTBREAK: 'FASTBREAK',
  SECOND_CHANCE: 'SECOND_CHANCE',
};

// Tag click detection delay (single vs double click) in ms
export const TAG_CLICK_DELAY_MS = 250;

// Default video offset applied when recording an action (seconds)
export const DEFAULT_VIDEO_OFFSET = -5;

// Extra offset applied for tags (tags describe longer plays)
export const TAG_EXTRA_OFFSET = -5;
